var $54b47fc030b7b21e$exports = {};
const $54b47fc030b7b21e$var$langBtn = document.querySelector(".l-language");
const $54b47fc030b7b21e$var$footer = document.querySelector("footer");
const $54b47fc030b7b21e$var$margin = 33;
function $54b47fc030b7b21e$var$updateLangBtnPosition() {
    const footerTop = $54b47fc030b7b21e$var$footer.getBoundingClientRect().top;
    const viewportHeight = window.innerHeight;
    const footerVisible = viewportHeight - footerTop;
    if (footerVisible > 0) $54b47fc030b7b21e$var$langBtn.style.bottom = footerVisible + $54b47fc030b7b21e$var$margin + "px";
    else $54b47fc030b7b21e$var$langBtn.style.bottom = $54b47fc030b7b21e$var$margin + "px";
}
window.addEventListener("scroll", $54b47fc030b7b21e$var$updateLangBtnPosition, {
    passive: true
});
$54b47fc030b7b21e$var$updateLangBtnPosition();


//# sourceMappingURL=index.b276c259.js.map
